import { z } from 'zod';

import { UnableToParseValue } from '../exceptions';
import { FieldValues } from '../types';

import { NumberValidator } from './number-validator';

export class FloatValidator extends NumberValidator {
    constructor() {
        super('float');
    }

    parse(fieldValue: unknown, allFields: FieldValues): number | undefined {
        try {
            return z.number().optional().parse(fieldValue);
        } catch (zodErrors: any) {
            throw new UnableToParseValue(fieldValue);
        }
    }
}
